module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Chapitre Un")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.00em",
      "text-transform": "uppercase"
    }
  }, [_vm._v("ADAM")]), _vm._v(" Preston quitta ses tongs et plongea ses orteils dans le sable chaud de chaque côté de la chaise longue. Une serveuse vêtue d’un uniforme blanc et bleu vif lui sourit et posa une bière et un shot de rhum vieux sur la petite table sous la palapa "), _c('a', {
    attrs: {
      "id": "ref_footnotebookmark_start_10_1"
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ref_footnotebookmark_end_10_1"
    }
  }, [_vm._v("1")])]), _vm._v(" d’Adam. Les feuilles de palmier bruissaient dans la brise légère provenant de la mer et l’odeur du sel lui chatouillait le nez. Des vagues bordées d’écume s’écrasaient sur la plage, quelques mètres plus loin. Le paradis.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Puis-je vous apporter autre chose, monsieur ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Non. Merci. C’est parfait.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Très bien, dit la femme. Faites-moi signe si vous avez besoin d’un autre verre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je le ferai. Merci.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Adam avala le rhum en une seule gorgée, reposa le verre à liqueur sur la table, puis il s’allongea et ferma les yeux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Vingt-quatre heures auparavant, il s’était disputé au téléphone avec son frère, essayant de le convaincre encore une fois qu’accepter l’offre d’Entech, qui voulait acheter l’entreprise familiale, était une énorme erreur. Non que cela ait fonctionné. Roger s’était toujours opposé à ce qu’Adam soit à la tête de Prestco inc., même s’il avait voté à contrecœur avec le reste de la famille afin de permettre à son frère de succéder à son père cinq ans auparavant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Cinq ans d’exploitation de Prestco signifiaient cinq années de travail pendant soixante heures et plus par semaine, mais Adam avait réussi à sauver ce qui restait de l’entreprise après la mort de son père.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il n’avait pas voulu reprendre l’entreprise de fournitures électroniques ; il voulait seulement poursuivre son pauvre rêve de coder et, peut-être, lancer un jour sa propre entreprise de logiciels. Il ne devrait pas se soucier de savoir si Entech les rachetait. Mais maintenant qu’Entech augmentait la pression, il se rendait compte qu’il ne voulait pas vendre. L’entreprise était devenue pour lui plus que ce que son père avait construit. Il n’accepterait pas de vendre. Il ne pouvait pas…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Laisse tomber. Tu es là pour te détendre, pas pour rejouer le même film jusqu’à ce que tu mémorises tous les dialogues.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il ouvrit les yeux et observa la lente descente du soleil. Il inspira longuement plusieurs fois et voulut se libérer de la tension qui pesait fortement sur ses épaules. Sa sœur avait raison. Il avait besoin de ces vacances. D’une semaine de paix et de calme. D’un temps de réflexion.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il termina sa bière et était sur le point de faire signe à une serveuse de lui en apporter une autre lorsqu’il se rendit compte qu’il avait oublié de se renseigner sur la possibilité d’une plongée le lendemain matin. Il était presque vingt heures, à peu près l’heure à laquelle le centre de plongée fermait d’après ce qu’on lui avait indiqué. La boisson pouvait attendre.")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "0",
      "width": "30%"
    }
  }), _c('p', {
    staticClass: "P_Footnote"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#ref_footnotebookmark_start_10_1",
      "id": "ref_footnotebookmark_end_10_1"
    }
  }, [_vm._v("1")])]), _vm._v("  Grand parasol fixe fait avec du chaume ou des feuilles de palmiers au lieu de toile.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd886142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0005.vue
// module id = 69
// module chunks = 0